import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { UBAccountDetails } from "@tylertech/tyler-api-types";
import
{
    IConsumptionChartData,
    IConsumptionChartParams,
    IUBAccountBill,
    IUBAccountFinancial,
    IUBAccountPastDue,
    IUBAccountServiceDTO,
    IUBAccountTransaction,
} from "../interfaces";

/**
 * TODO - Tyler.API.UtilityBilling.Services.IAccountManagerService could be attributed to have the Ts Generator emit this implementation for us.
 */
@Injectable()
export class AccountManagerService
{
    private readonly $apiService = inject(ApiService);


    canEditTaxParcelNumber(): Promise<boolean>
    {
        return this.$apiService.sendAuth("IAccountManagerService/CanEditTaxParcelNumber");
    }

    getConsumption(params: IConsumptionChartParams): Promise<IConsumptionChartData>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetConsumption", params);
    }

    getDetails(accountId: string): Promise<UBAccountDetails>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetDetails", accountId);
    }

    getFinancialDetails(accountId: string): Promise<IUBAccountFinancial>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetFinancialDetails", accountId);
    }

    getLastBill(accountId: string): Promise<IUBAccountBill[]>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetLastBill", accountId);
    }

    getPastDue(accountId: string): Promise<IUBAccountPastDue>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetPastDue", accountId);
    }

    getServices(accountId: string): Promise<IUBAccountServiceDTO[]>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetServices", accountId);
    }

    getTransactionHistory(accountId: string): Promise<IUBAccountTransaction[]>
    {
        return this.$apiService.sendAuth("IAccountManagerService/GetTransactionHistory", accountId);
    }

    saveDetails(contact: UBAccountDetails): Promise<boolean>
    {
        return this.$apiService.sendAuth("IAccountManagerService/SaveDetails", contact);
    }

    updateDetails(contact: UBAccountDetails): Promise<boolean>
    {
        return this.$apiService.sendAuth("IAccountManagerService/UpdateDetails", contact);
    }
}
